import { Component, OnInit, Input } from '@angular/core';

/**
 * Display files
 * @param archivos, File[]
 * @example 
 * ```html
 * <app-files [archivos]="archivos"></app-files>
 * ```
 */
@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})
export class FilesComponent implements OnInit {


  @Input('archivos') archivos: File[];
  constructor() { }

  ngOnInit(): void {
  }

}
